<div class="tool-content-container">
  <div class="tool-description">
    Enter a Student ID and click submit to view the student's academic profile.
    <!-- <b class="instructions-title">To generate results for student profile:</b
    ><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Enter a Student ID<br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Click on the submit button<br /><br /> -->
  </div>

  <div class="student-content-container">
    <!------------------------------------ Overview Card Container ------------------------------------>

    <div class="toggle-button-div" *ngIf="studentData">
      <mat-button-toggle-group>
        <mat-button-toggle
          value="default"
          aria-label="Default"
          [ngStyle]="{
            'background-color':
              group === 'default' ? env['colors']['tool_btn_active'] : 'white',
            'font-weight': group === 'default' ? 700 : 'inherit',
            color: group === 'default' ? env['colors']['primary'] : 'black',
          }"
          (click)="toggleCards()"
        >
          Default
        </mat-button-toggle>
        <mat-button-toggle
          value="entry-characteristics"
          aria-label="Entry Characteristics"
          [ngStyle]="{
            'background-color':
              group === 'entry-characteristics'
                ? env['colors']['tool_btn_active']
                : 'white',
            'font-weight': group === 'entry-characteristics' ? 700 : 'inherit',
            color:
              group === 'entry-characteristics'
                ? env['colors']['primary']
                : 'black',
          }"
          (click)="toggleCards()"
        >
          Entry Characteristics
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

  <!------------------------------------ Cards Container ------------------------------------>
  <div class="cards-container" *ngIf="studentData">
    <div
      *ngIf="group === 'default'; else elseBlock"
      [style.width.px]="cardsContainerWidth"
      [style.margin]="'auto'"
    >
      <mat-grid-list [cols]="numCardCols" rowHeight="120px">
        <mat-grid-tile>
          <mat-card
            class="mat-card-style"
            [ngClass]="{
              'tier-1':
                studentData.admit_type === 'FTIC' && studentData.tier === 1,
              'tier-2':
                studentData.admit_type === 'FTIC' && studentData.tier === 2,
              'tier-3':
                studentData.admit_type === 'FTIC' && studentData.tier === 3,
              'tier-4':
                studentData.admit_type === 'FTIC' && studentData.tier === 4,
              'tier-5':
                studentData.admit_type === 'FTIC' && studentData.tier === 5,
            }"
            matTooltip="Last Enrolled: {{
              studentData.last_semester_attended || 'NA'
            }}; Max SEP: {{ studentData.sep_max_grad_year || 'NA' }}"
            aria-label="Button that displays a tooltip when focused or hovered over"
            matTooltipClass="tooltip tooltip-extra"
          >
            <mat-card-title-group>
              <mat-card-title>Enrollment Status:</mat-card-title>
            </mat-card-title-group>
            <mat-card-content>{{ getEnrollmentStatus() }}</mat-card-content>
          </mat-card>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-card
            class="mat-card-style"
            [ngClass]="{
              'tier-1':
                studentData.admit_type === 'FTIC' && studentData.tier === 1,
              'tier-2':
                studentData.admit_type === 'FTIC' && studentData.tier === 2,
              'tier-3':
                studentData.admit_type === 'FTIC' && studentData.tier === 3,
              'tier-4':
                studentData.admit_type === 'FTIC' && studentData.tier === 4,
              'tier-5':
                studentData.admit_type === 'FTIC' && studentData.tier === 5,
            }"
            matTooltip="Type of Degree: {{
              studentData.degree_type || 'NA'
            }}; Degree(s): {{
              studentData.degrees.length ? studentData.degrees.join(', ') : 'NA'
            }}; Cohort year: {{ studentData.cohort }};"
            aria-label="Button that displays a tooltip when focused or hovered over"
            matTooltipClass="tooltip"
          >
            <mat-card-title-group>
              <mat-card-title>Graduation Status:</mat-card-title>
            </mat-card-title-group>
            <mat-card-content
              [ngStyle]="{
                color: getGraduationStatus().includes('OnTime')
                  ? 'green'
                  : getGraduationStatus().includes('OverTime')
                    ? 'orange'
                    : 'red',
              }"
            >
              {{ getGraduationStatus() }}
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-card
            class="mat-card-style"
            [ngClass]="{
              'tier-1':
                studentData.admit_type === 'FTIC' && studentData.tier === 1,
              'tier-2':
                studentData.admit_type === 'FTIC' && studentData.tier === 2,
              'tier-3':
                studentData.admit_type === 'FTIC' && studentData.tier === 3,
              'tier-4':
                studentData.admit_type === 'FTIC' && studentData.tier === 4,
              'tier-5':
                studentData.admit_type === 'FTIC' && studentData.tier === 5,
            }"
            matTooltip="Last Term Cumulative GPA: {{
              studentData.prev_cumulative_gpa
            }};"
            aria-label="Button that displays a tooltip when focused or hovered over"
            matTooltipClass="tooltip"
          >
            <mat-card-title-group>
              <mat-card-title>Cumulative GPA:</mat-card-title>
            </mat-card-title-group>
            <mat-card-content>
              {{ studentData.uwf_cumulative_gpa }}
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-card
            class="mat-card-style"
            [ngClass]="{
              'tier-1':
                studentData.admit_type === 'FTIC' && studentData.tier === 1,
              'tier-2':
                studentData.admit_type === 'FTIC' && studentData.tier === 2,
              'tier-3':
                studentData.admit_type === 'FTIC' && studentData.tier === 3,
              'tier-4':
                studentData.admit_type === 'FTIC' && studentData.tier === 4,
              'tier-5':
                studentData.admit_type === 'FTIC' && studentData.tier === 5,
            }"
            matTooltip="Cumulative Univ Hours: {{
              studentData.total_univ_hours
            }}"
            aria-label="Button that displays a tooltip when focused or hovered over"
            matTooltipClass="tooltip"
          >
            <mat-card-title-group>
              <mat-card-title>Current Year at UWF:</mat-card-title>
            </mat-card-title-group>
            <mat-card-content>{{
              studentData.year === -1 ? 'NA' : studentData.year
            }}</mat-card-content>
          </mat-card>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-card
            class="mat-card-style"
            [ngClass]="{
              'tier-1':
                studentData.admit_type === 'FTIC' && studentData.tier === 1,
              'tier-2':
                studentData.admit_type === 'FTIC' && studentData.tier === 2,
              'tier-3':
                studentData.admit_type === 'FTIC' && studentData.tier === 3,
              'tier-4':
                studentData.admit_type === 'FTIC' && studentData.tier === 4,
              'tier-5':
                studentData.admit_type === 'FTIC' && studentData.tier === 5,
            }"
            matTooltip="Core Hours: {{ studentData.total_core_hours }}"
            aria-label="Button that displays a tooltip when focused or hovered over"
            matTooltipClass="tooltip"
          >
            <mat-card-title-group>
              <mat-card-title>Current Registered Hours:</mat-card-title>
            </mat-card-title-group>
            <mat-card-content>
              {{ studentData.curr_term_load_hrs || 'NA' }}
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-card
            class="mat-card-style"
            [ngClass]="{
              'tier-1':
                studentData.admit_type === 'FTIC' && studentData.tier === 1,
              'tier-2':
                studentData.admit_type === 'FTIC' && studentData.tier === 2,
              'tier-3':
                studentData.admit_type === 'FTIC' && studentData.tier === 3,
              'tier-4':
                studentData.admit_type === 'FTIC' && studentData.tier === 4,
              'tier-5':
                studentData.admit_type === 'FTIC' && studentData.tier === 5,
            }"
            matTooltip="Retention Probability {{
              studentData.retention_probability || 'NA'
            }}; Risk Factors: {{ studentData.risk_factors || 'NA' }}"
            aria-label="Button that displays a tooltip when focused or hovered over"
            matTooltipClass="tooltip"
          >
            <mat-card-title-group>
              <mat-card-title>Dropout Risk</mat-card-title>
            </mat-card-title-group>
            <mat-card-content
              [style]="{
                color:
                  studentData.dropout_risk === 'Low Risk'
                    ? 'green'
                    : studentData.dropout_risk === 'Medium Risk'
                      ? 'orange'
                      : studentData.dropout_risk === 'High Risk'
                        ? 'red'
                        : 'black',
              }"
            >
              {{ studentData.dropout_risk || 'NA' }}
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
      </mat-grid-list>
    </div>

    <ng-template #elseBlock>
      <div [style.width.px]="cardsContainerWidth" [style.margin]="'auto'">
        <mat-grid-list [cols]="numCardCols" rowHeight="120px">
          <mat-grid-tile>
            <mat-card
              class="mat-card-style"
              [ngClass]="{
                'tier-1':
                  studentData.admit_type === 'FTIC' && studentData.tier === 1,
                'tier-2':
                  studentData.admit_type === 'FTIC' && studentData.tier === 2,
                'tier-3':
                  studentData.admit_type === 'FTIC' && studentData.tier === 3,
                'tier-4':
                  studentData.admit_type === 'FTIC' && studentData.tier === 4,
                'tier-5':
                  studentData.admit_type === 'FTIC' && studentData.tier === 5,
              }"
              matTooltip="Race: {{ studentData.ethnicity }}; Gender: {{
                studentData.gender
              }}{{
                studentData.admit_type === 'FTIC'
                  ? '; Tier: ' + studentData.tier || 'NA'
                  : ''
              }}; Current semester fund type: {{ financialAidGiven }};"
              aria-label="Button that displays a tooltip when focused or hovered over"
              matTooltipClass="tooltip tooltip-extra"
            >
              <mat-card-title-group>
                <mat-card-title>Student ID</mat-card-title>
              </mat-card-title-group>
              <mat-card-content
                >{{ studentData.uwf_id }} <br />
                {{
                  (studentData.first_name || '') +
                    ' ' +
                    (studentData.last_name || '') +
                    ' (' +
                    studentData.admit_type +
                    ')'
                }}</mat-card-content
              >
            </mat-card>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="studentData.admit_type === 'FTIC'">
            <mat-card
              class="mat-card-style"
              [ngClass]="{
                'tier-1': studentData.tier === 1,
                'tier-2': studentData.tier === 2,
                'tier-3': studentData.tier === 3,
                'tier-4': studentData.tier === 4,
                'tier-5': studentData.tier === 5,
              }"
              matTooltip="High School GPA: {{
                studentData.high_school_gpa === -1
                  ? 'NA'
                  : studentData.high_school_gpa
              }}"
              aria-label="Button that displays a tooltip when focused or hovered over"
              matTooltipClass="tooltip"
            >
              <mat-card-title-group>
                <mat-card-title>First Fall GPA</mat-card-title>
              </mat-card-title-group>
              <mat-card-content>
                {{
                  studentData.uwf_gpas[0].value === -1
                    ? 'NA'
                    : studentData.uwf_gpas[0].value
                }}
              </mat-card-content>
            </mat-card>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-card
              class="mat-card-style"
              [ngClass]="{
                'tier-1':
                  studentData.admit_type === 'FTIC' && studentData.tier === 1,
                'tier-2':
                  studentData.admit_type === 'FTIC' && studentData.tier === 2,
                'tier-3':
                  studentData.admit_type === 'FTIC' && studentData.tier === 3,
                'tier-4':
                  studentData.admit_type === 'FTIC' && studentData.tier === 4,
                'tier-5':
                  studentData.admit_type === 'FTIC' && studentData.tier === 5,
              }"
              matTooltip="Prior Hours: {{ studentData.prior_hours }}"
              aria-label="Button that displays a tooltip when focused or hovered over"
              matTooltipClass="tooltip"
            >
              <mat-card-title-group>
                <mat-card-title>Hours Earned</mat-card-title>
              </mat-card-title-group>
              <mat-card-content>
                {{
                  $any(
                    getValueOnStudentAttribute(
                      studentData.hours_trend!['self_univ_hours']
                    )
                  )
                }}
              </mat-card-content>
            </mat-card>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-card
              class="mat-card-style"
              [ngClass]="{
                'tier-1':
                  studentData.admit_type === 'FTIC' && studentData.tier === 1,
                'tier-2':
                  studentData.admit_type === 'FTIC' && studentData.tier === 2,
                'tier-3':
                  studentData.admit_type === 'FTIC' && studentData.tier === 3,
                'tier-4':
                  studentData.admit_type === 'FTIC' && studentData.tier === 4,
                'tier-5':
                  studentData.admit_type === 'FTIC' && studentData.tier === 5,
              }"
              matTooltip="{{
                studentData.admit_type === 'FTIC'
                  ? 'First Fall Program: ' +
                    getFirstTermProgramStudentAttribute(
                      studentData['program_cip_descs']
                    ) +
                    '; '
                  : ''
              }} College: {{
                getValueOnStudentAttribute(studentData['colleges'])
              }}"
              aria-label="Button that displays a tooltip when focused or hovered over"
              matTooltipClass="tooltip"
            >
              <mat-card-title-group>
                <mat-card-title>Current Program</mat-card-title>
              </mat-card-title-group>
              <mat-card-content>{{
                getValueOnStudentAttribute(studentData['program_cip_descs'])
              }}</mat-card-content>
            </mat-card>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="studentData.admit_type === 'FTIC'">
            <mat-card
              class="mat-card-style"
              [ngClass]="{
                'tier-1': studentData.tier === 1,
                'tier-2': studentData.tier === 2,
                'tier-3': studentData.tier === 3,
                'tier-4': studentData.tier === 4,
                'tier-5': studentData.tier === 5,
              }"
              matTooltip="1st Term APR Probability: {{
                studentData.prob_apr_1st_term || 'NA'
              }}"
              aria-label="Button that displays a tooltip when focused or hovered over"
              matTooltipClass="tooltip"
            >
              <mat-card-title-group>
                <mat-card-title
                  >Pre-college APR Probability (ARM)</mat-card-title
                >
              </mat-card-title-group>
              <mat-card-content>
                {{ studentData.prob_apr_arm || 'NA' }}
              </mat-card-content>
            </mat-card>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="studentData.admit_type === 'FTIC'">
            <mat-card
              class="mat-card-style"
              [ngClass]="{
                'tier-1': studentData.tier === 1,
                'tier-2': studentData.tier === 2,
                'tier-3': studentData.tier === 3,
                'tier-4': studentData.tier === 4,
                'tier-5': studentData.tier === 5,
              }"
              matTooltip="Year of Pell: {{
                studentData.first_semester_pell_ind ? studentData.cohort : 'NA'
              }}; Current Pell: TBD"
              aria-label="Button that displays a tooltip when focused or hovered over"
              matTooltipClass="tooltip"
            >
              <mat-card-title-group>
                <mat-card-title>First Year Pell Grant:</mat-card-title>
              </mat-card-title-group>
              <mat-card-content>
                {{ studentData.first_semester_pell_ind ? 'Yes' : 'No' }}
              </mat-card-content>
            </mat-card>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </ng-template>
  </div>
  <!------------------------------------ Cards Container ------------------------------------>

  <!-- Begin Risk Comments table-->
  <mat-accordion class="courses-table mat-elevation-z8" *ngIf="studentData">
    <mat-expansion-panel
      [expanded]="false"
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header
        [style]="{
          'background-color': isAtRisk
            ? 'rgba(186, 30, 30, 0.1)'
            : studentData.demo_time_frame !== dataService.getCurrentSemester()
              ? 'rgba(142, 144, 145, 0.5)'
              : 'rgba(30, 186, 30, 0.1)',
        }"
      >
        <mat-panel-title>
          <h3>At-Risk Status and Comments</h3>
          <a
            color="primary"
            class="mark-at-risk-btn"
            mat-fab
            extended
            *ngIf="authService.hasPermission('at-risk-students', true)"
            matTooltip="Mark At Risk"
            [disabled]="
              isAtRisk ||
              studentData.demo_time_frame !== dataService.getCurrentSemester()
            "
            (click)="markAtRisk($event)"
          >
            <mat-icon>report</mat-icon>
            Mark at-risk
          </a>
        </mat-panel-title>
        <mat-panel-description
          [style]="{
            color: isAtRisk
              ? 'red'
              : studentData.demo_time_frame !== dataService.getCurrentSemester()
                ? 'black'
                : 'green',
          }"
        >
          {{
            isAtRisk
              ? 'At Risk'
              : studentData.demo_time_frame !== dataService.getCurrentSemester()
                ? ' Unavailable - Cannot be marked at-risk if not enrolled (inactive) in current semester'
                : 'Not At Risk'
          }}
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-accordion *ngFor="let atRiskData of this.studentData.at_risk_data">
        <mat-expansion-panel
          [expanded]="false"
          (opened)="panelOpenState = true"
          (closed)="panelOpenState = false"
          style="margin-top: 15px"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h3>At-Risk Semester: {{ atRiskData.demo_time_frame }}</h3>
              <button
                *ngIf="authService.hasPermission('at-risk-students', true)"
                class="add-risk-comment-btn"
                mat-icon-button
                aria-label="add risk comment button"
                matTooltip="Add At-Risk Comment"
                (click)="addAtRiskComment($event, atRiskData)"
                [disabled]="
                  atRiskData.demo_time_frame < dataService.getCurrentSemester()
                "
              >
                <mat-icon aria-hidden="false" aria-label="Delete"
                  >add_circle
                </mat-icon>
              </button>
              <button
                *ngIf="authService.hasPermission('at-risk-students', true)"
                class="delete-at-risk-record-btn"
                mat-icon-button
                aria-label="delete at-risk button"
                matTooltip="Delete At-Risk"
                (click)="deleteAtRiskStudent($event, atRiskData.id)"
              >
                <mat-icon aria-hidden="false" aria-label="Delete"
                  >delete_forever
                </mat-icon>
              </button>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <table
            mat-table
            [dataSource]="atRiskCommentDataSource[atRiskData.id]"
          >
            <!-- Comment -->
            <ng-container matColumnDef="comment">
              <th mat-header-cell *matHeaderCellDef>Comment</th>
              <td mat-cell *matCellDef="let element">
                {{ element.comment }}
              </td>
            </ng-container>

            <!-- Categories -->
            <ng-container matColumnDef="categories">
              <th mat-header-cell *matHeaderCellDef>Categories</th>
              <td mat-cell *matCellDef="let element">
                {{ element.categories }}
              </td>
            </ng-container>

            <!-- Advisor -->
            <ng-container matColumnDef="made_by">
              <th mat-header-cell *matHeaderCellDef>Made By</th>
              <td mat-cell *matCellDef="let element">
                {{ element.made_by }}
              </td>
            </ng-container>

            <!-- Created At -->
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef>Created At</th>
              <td mat-cell *matCellDef="let element">
                {{ element.createdAt }}
              </td>
            </ng-container>

            <ng-container
              matColumnDef="action"
              *ngIf="authService.hasPermission('at-risk-students', true)"
            >
              <th mat-header-cell *matHeaderCellDef>Action</th>
              <td mat-cell *matCellDef="let element">
                <button
                  mat-icon-button
                  aria-label="delete risk comment button"
                  matTooltip="Delete Risk Comment"
                  (click)="deleteAtRiskComment(atRiskData.id, element.id)"
                >
                  <mat-icon aria-hidden="false" aria-label="Delete"
                    >delete_forever
                  </mat-icon>
                </button>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="riskCommmentDisplayedColumns"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: riskCommmentDisplayedColumns"
            ></tr>
          </table>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-expansion-panel>
  </mat-accordion>

  <!------------- Registered Courses Table with inner table to show canvas report data ------------->
  <mat-accordion
    class="courses-table mat-elevation-z8"
    *ngIf="registeredCoursesData?.length"
  >
    <mat-expansion-panel
      [expanded]="true"
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h3>{{ getRegisteredCoursesTerm() }} Registered Courses</h3>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <table
        mat-table
        [dataSource]="registeredCoursesData"
        multiTemplateDataRows
      >
        <!-- Course Code Column -->
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef>Course Code</th>
          <td mat-cell *matCellDef="let course">
            <p
              [ngClass]="{
                'canvas-data-okay':
                  getCanvasDataGradeStatus(
                    registeredCoursesData,
                    course.course_code
                  ) === 'Okay',
                'canvas-data-risk':
                  getCanvasDataGradeStatus(
                    registeredCoursesData,
                    course.course_code
                  ) === 'Risk',
                'canvas-data-fail':
                  getCanvasDataGradeStatus(
                    registeredCoursesData,
                    course.course_code
                  ) === 'Fail',
                'canvas-data-not-available':
                  getCanvasDataGradeStatus(
                    registeredCoursesData,
                    course.course_code
                  ) === 'Not Available',
              }"
            >
              {{ course.course_code }}
            </p>
          </td>
        </ng-container>

        <!-- Course Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Course Name</th>
          <td mat-cell *matCellDef="let course">{{ course.course_name }}</td>
        </ng-container>

        <!-- Credit Hours Column -->
        <ng-container matColumnDef="hours">
          <th mat-header-cell *matHeaderCellDef>Credit Hours</th>
          <td mat-cell *matCellDef="let course">{{ course.course_hrs }}</td>
        </ng-container>

        <!-- Pass Rate Column -->
        <ng-container matColumnDef="pass_rate">
          <th mat-header-cell *matHeaderCellDef>Pass Rate</th>
          <td mat-cell *matCellDef="let course">
            {{ course.pass_rate > -1 ? course.pass_rate : 'NA' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="grade_awarded">
          <th mat-header-cell *matHeaderCellDef>Grade Awarded</th>
          <td mat-cell *matCellDef="let course">
            {{ course.grade_awarded || 'NA' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="grade_prediction">
          <th mat-header-cell *matHeaderCellDef>Grade Prediction</th>
          <td mat-cell *matCellDef="let course">
            {{ course.grade_prediction || 'NA' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="delivery_method">
          <th mat-header-cell *matHeaderCellDef>Delivery Method</th>
          <td mat-cell *matCellDef="let course">
            {{ course.delivery_method || 'NA' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="rank">
          <th mat-header-cell *matHeaderCellDef>
            Personalized Difficulty Rank <br />
            (1 = Easy)
          </th>
          <td mat-cell *matCellDef="let course">
            {{ course.rank || 'NA' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element">
            <button
              class="expand-btn"
              (click)="
                expandedElement = expandedElement === element ? null : element;
                setInnerTableDataSource(
                  registeredCoursesData[0].demo_time_frame
                )
              "
              mat-icon-button
              aria-label="expand comment table"
            >
              <mat-icon>{{
                expandedElement === element ? 'expand_less' : 'expand_more'
              }}</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumnsRegistered.length"
          >
            <div
              class="example-element-detail"
              [@detailExpand]="
                element == expandedElement ? 'expanded' : 'collapsed'
              "
            >
              <table
                mat-table
                [dataSource]="
                  getInnerTableDataSource(
                    registeredCoursesData[0].demo_time_frame
                  )
                "
                class="mat-elevation-z8 inner-table"
              >
                <!-- Course Section -->
                <ng-container matColumnDef="course_section">
                  <th mat-header-cell *matHeaderCellDef>Course Section</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.course_section || 'NA' }}
                  </td>
                </ng-container>

                <!-- Demo Time Frame -->
                <ng-container matColumnDef="demo_time_frame">
                  <th mat-header-cell *matHeaderCellDef>Demo Time Frame</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.demo_time_frame || 'NA' }}
                  </td>
                </ng-container>

                <!-- Enrollment State -->
                <ng-container matColumnDef="enrollment_state">
                  <th mat-header-cell *matHeaderCellDef>Enrollment State</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.enrollment_state || 'NA' }}
                  </td>
                </ng-container>

                <!-- Grade Score -->
                <ng-container matColumnDef="grade_score">
                  <th mat-header-cell *matHeaderCellDef>Grade Score</th>
                  <td mat-cell *matCellDef="let element">
                    {{
                      element.grade_score === null ? 'NA' : element.grade_score
                    }}
                  </td>
                </ng-container>

                <!-- Grade Status -->
                <ng-container matColumnDef="grade_status">
                  <th mat-header-cell *matHeaderCellDef>Grade Status</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.grade_status || 'NA' }}
                  </td>
                </ng-container>

                <!-- Last Interaction Time -->
                <ng-container matColumnDef="last_interaction_time">
                  <th mat-header-cell *matHeaderCellDef>
                    Last Interaction Time
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.last_interaction_time }}
                  </td>
                </ng-container>

                <!-- No Interactions -->
                <ng-container matColumnDef="interacted_with_course">
                  <th mat-header-cell *matHeaderCellDef>
                    Interacted with Course
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.interacted_with_course || 'NA' }}
                  </td>
                </ng-container>

                <!-- Week -->
                <ng-container matColumnDef="week">
                  <th mat-header-cell *matHeaderCellDef>Week</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.week || 'NA' }}
                  </td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="innerDisplayedColumns"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: innerDisplayedColumns"
                ></tr>
              </table>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsRegistered"></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: displayedColumnsRegistered"
          class="example-element-row"
          [class.example-expanded-row]="expandedElement === element"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="example-detail-row"
        ></tr>
      </table>
    </mat-expansion-panel>
  </mat-accordion>

  <!------------- Courses combinations Table ------------->
  <mat-accordion
    class="courses-table mat-elevation-z8"
    *ngIf="courseCombos?.length"
  >
    <mat-expansion-panel
      [expanded]="true"
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h3>Course Combinations</h3>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="courseComboDataSource">
        <!-- Course Combos Column -->
        <ng-container matColumnDef="courses">
          <th mat-header-cell *matHeaderCellDef>Course Combos</th>
          <td mat-cell *matCellDef="let course">{{ course.courses }}</td>
        </ng-container>

        <!-- Pass Rate Column -->
        <ng-container matColumnDef="pass_rate">
          <th mat-header-cell *matHeaderCellDef>Pass Rate</th>
          <td mat-cell *matCellDef="let course">
            {{ course.pass_rate > -1 ? course.pass_rate : 'NA' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsCourseCombo"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsCourseCombo"
        ></tr>
      </table>
      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </mat-expansion-panel>
  </mat-accordion>

  <!-------------------- Recommended Courses Table Container -------------------->

  <mat-accordion
    class="courses-table mat-elevation-z8"
    *ngIf="recommendedCourses?.length"
  >
    <mat-expansion-panel
      [expanded]="true"
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h3>Course Recommender ({{ type }}) {{ new_demo_time_frame }}</h3>
        </mat-panel-title>
        <mat-panel-description>
          <div class="recommended-course-head-div">
            <h3>{{ type_desc }}</h3>
            <button
              (click)="switchTable($event)"
              id="icon-button"
              mat-mini-fab
              matTooltip="Course recommender options. Click here to go to the next category."
            >
              <mat-icon>navigate_next</mat-icon>
            </button>
          </div>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="recommendedCourses">
        <!-- Course Code Column -->
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef>Course Code</th>
          <td mat-cell *matCellDef="let course">{{ course.course_code }}</td>
        </ng-container>

        <!-- Course Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Course Name</th>
          <td mat-cell *matCellDef="let course">{{ course.course_name }}</td>
        </ng-container>

        <!-- Course Name Column -->
        <ng-container matColumnDef="pass_rate">
          <th mat-header-cell *matHeaderCellDef>Pass Rate</th>
          <td mat-cell *matCellDef="let course">
            {{ course.pass_rate > -1 ? course.pass_rate : 'NA' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsRecommended"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsRecommended"
        ></tr>
      </table>
    </mat-expansion-panel>
  </mat-accordion>

  <!-------------------- Taken Courses Table Container -------------------->
  <ng-container *ngIf="studentData">
    <mat-form-field id="filterInputStyle">
      <mat-label>Filter for Taken Courses</mat-label>
      <input
        matInput
        #filterInput
        (input)="filterForCourse($event)"
        placeholder="COP3022"
        #input
      />
      <button
        *ngIf="filterInput"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="resetFilter(filterInput)"
      >
        <i class="fas fa-times-circle"></i>
      </button>
    </mat-form-field>
    <ng-container *ngFor="let item of studentData.taken_data | keyvalue">
      <div *ngIf="showAllTable; else elseBlock">
        <!-- Content to render if condition is true -->
        <mat-accordion
          class="courses-table mat-elevation-z8"
          *ngIf="item.value.courses.length"
        >
          <mat-expansion-panel
            [expanded]="false"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h3>
                  {{ getTakenCoursesTerm(+item.key) }}
                  Taken Courses
                </h3>
              </mat-panel-title>
              <mat-panel-description>
                Term GPA:
                {{ item.value.term_gpa === null ? 'NA' : item.value.term_gpa }}
                | Registered Hours: {{ item.value.registered_hours }} | DWF
                Hours: {{ item.value.dwf_hours }}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <table
              mat-table
              [dataSource]="item.value.courses"
              multiTemplateDataRows
            >
              <!-- Course Code Column -->
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef>Course Code</th>
                <td mat-cell *matCellDef="let course">
                  <p
                    [ngClass]="{
                      'canvas-data-okay':
                        getCanvasDataGradeStatus(
                          item.value.courses,
                          course.course_code
                        ) === 'Okay',
                      'canvas-data-risk':
                        getCanvasDataGradeStatus(
                          item.value.courses,
                          course.course_code
                        ) === 'Risk',
                      'canvas-data-fail':
                        getCanvasDataGradeStatus(
                          item.value.courses,
                          course.course_code
                        ) === 'Fail',
                      'canvas-data-not-available':
                        getCanvasDataGradeStatus(
                          item.value.courses,
                          course.course_code
                        ) === 'Not Available',
                    }"
                  >
                    {{ course.course_code }}
                  </p>
                </td>
              </ng-container>

              <!-- Course Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Course Name</th>
                <td mat-cell *matCellDef="let course">
                  {{ course.course_name }}
                </td>
              </ng-container>

              <!-- Credit Hours Column -->
              <ng-container matColumnDef="hours">
                <th mat-header-cell *matHeaderCellDef>Credit Hours</th>
                <td mat-cell *matCellDef="let course">
                  {{ course.course_hrs }}
                </td>
              </ng-container>

              <!-- Pass Rate Column -->
              <ng-container matColumnDef="pass_rate">
                <th mat-header-cell *matHeaderCellDef>Pass Rate</th>
                <td mat-cell *matCellDef="let course">
                  {{ course.pass_rate > -1 ? course.pass_rate : 'NA' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="grade_awarded">
                <th mat-header-cell *matHeaderCellDef>Grade Awarded</th>
                <td mat-cell *matCellDef="let course">
                  {{ course.grade_awarded || 'NA' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="grade_prediction">
                <th mat-header-cell *matHeaderCellDef>Grade Prediction</th>
                <td mat-cell *matCellDef="let course">
                  {{ course.grade_prediction || 'NA' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="rank">
                <th mat-header-cell *matHeaderCellDef>
                  Personalized Difficulty Rank <br />
                  (1 = Easy)
                </th>
                <td mat-cell *matCellDef="let course">
                  {{ course.rank || 'NA' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="delivery_method">
                <th mat-header-cell *matHeaderCellDef>Delivery Method</th>
                <td mat-cell *matCellDef="let course">
                  {{ course.delivery_method || 'NA' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element">
                  <button
                    class="expand-btn"
                    (click)="
                      expandedElement =
                        expandedElement === element ? null : element;
                      setInnerTableDataSource(+item.key)
                    "
                    mat-icon-button
                    aria-label="expand comment table"
                  >
                    <mat-icon>{{
                      expandedElement === element
                        ? 'expand_less'
                        : 'expand_more'
                    }}</mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td
                  mat-cell
                  *matCellDef="let element"
                  [attr.colspan]="displayedColumnsRegistered.length"
                >
                  <div
                    class="example-element-detail"
                    [@detailExpand]="
                      element == expandedElement ? 'expanded' : 'collapsed'
                    "
                  >
                    <table
                      mat-table
                      [dataSource]="getInnerTableDataSource(+item.key)"
                      class="mat-elevation-z8 inner-table"
                    >
                      <!-- Course Section -->
                      <ng-container matColumnDef="course_section">
                        <th mat-header-cell *matHeaderCellDef>
                          Course Section
                        </th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.course_section || 'NA' }}
                        </td>
                      </ng-container>

                      <!-- Demo Time Frame -->
                      <ng-container matColumnDef="demo_time_frame">
                        <th mat-header-cell *matHeaderCellDef>
                          Demo Time Frame
                        </th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.demo_time_frame || 'NA' }}
                        </td>
                      </ng-container>

                      <!-- Enrollment State -->
                      <ng-container matColumnDef="enrollment_state">
                        <th mat-header-cell *matHeaderCellDef>
                          Enrollment State
                        </th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.enrollment_state || 'NA' }}
                        </td>
                      </ng-container>

                      <!-- Grade Score -->
                      <ng-container matColumnDef="grade_score">
                        <th mat-header-cell *matHeaderCellDef>Grade Score</th>
                        <td mat-cell *matCellDef="let element">
                          {{
                            element.grade_score === null
                              ? 'NA'
                              : element.grade_score
                          }}
                        </td>
                      </ng-container>

                      <!-- Grade Status -->
                      <ng-container matColumnDef="grade_status">
                        <th mat-header-cell *matHeaderCellDef>Grade Status</th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.grade_status || 'NA' }}
                        </td>
                      </ng-container>

                      <!-- Last Interaction Time -->
                      <ng-container matColumnDef="last_interaction_time">
                        <th mat-header-cell *matHeaderCellDef>
                          Last Interaction Time
                        </th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.last_interaction_time }}
                        </td>
                      </ng-container>

                      <!-- No Interactions -->
                      <ng-container matColumnDef="interacted_with_course">
                        <th mat-header-cell *matHeaderCellDef>
                          Interacted with Course
                        </th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.interacted_with_course || 'NA' }}
                        </td>
                      </ng-container>

                      <!-- Week -->
                      <ng-container matColumnDef="week">
                        <th mat-header-cell *matHeaderCellDef>Week</th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.week || 'NA' }}
                        </td>
                      </ng-container>

                      <tr
                        mat-header-row
                        *matHeaderRowDef="innerDisplayedColumns"
                      ></tr>
                      <tr
                        mat-row
                        *matRowDef="let row; columns: innerDisplayedColumns"
                      ></tr>
                    </table>
                  </div>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumnsRegistered"
              ></tr>
              <tr
                mat-row
                *matRowDef="let element; columns: displayedColumnsRegistered"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: ['expandedDetail']"
                class="example-detail-row"
              ></tr>
            </table>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <ng-template #elseBlock>
        <!-- Content to render if condition is false -->
        <div *ngFor="let eachDemoTimeFrame of filteredTakenCourse">
          <mat-accordion
            class="courses-table mat-elevation-z8"
            *ngIf="+item.key === eachDemoTimeFrame"
          >
            <mat-expansion-panel
              [expanded]="true"
              (opened)="panelOpenState = true"
              (closed)="panelOpenState = false"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h3>
                    {{ getTakenCoursesTerm(+item.key) }}
                    Taken Courses
                  </h3>
                </mat-panel-title>
                <mat-panel-description>
                  Term GPA:
                  {{
                    item.value.term_gpa === null ? 'NA' : item.value.term_gpa
                  }}
                </mat-panel-description>
              </mat-expansion-panel-header>

              <table
                mat-table
                [dataSource]="item.value.courses"
                multiTemplateDataRows
              >
                <!-- Course Code Column -->
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef>Course Code</th>
                  <td mat-cell *matCellDef="let course">
                    <p
                      [ngClass]="{
                        'canvas-data-okay':
                          getCanvasDataGradeStatus(
                            item.value.courses,
                            course.course_code
                          ) === 'Okay',
                        'canvas-data-risk':
                          getCanvasDataGradeStatus(
                            item.value.courses,
                            course.course_code
                          ) === 'Risk',
                        'canvas-data-fail':
                          getCanvasDataGradeStatus(
                            item.value.courses,
                            course.course_code
                          ) === 'Fail',
                        'canvas-data-not-available':
                          getCanvasDataGradeStatus(
                            item.value.courses,
                            course.course_code
                          ) === 'Not Available',
                      }"
                    >
                      {{ course.course_code }}
                    </p>
                  </td>
                </ng-container>

                <!-- Course Name Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Course Name</th>
                  <td mat-cell *matCellDef="let course">
                    {{ course.course_name }}
                  </td>
                </ng-container>

                <!-- Credit Hours Column -->
                <ng-container matColumnDef="hours">
                  <th mat-header-cell *matHeaderCellDef>Credit Hours</th>
                  <td mat-cell *matCellDef="let course">
                    {{ course.course_hrs }}
                  </td>
                </ng-container>

                <!-- Pass Rate Column -->
                <ng-container matColumnDef="pass_rate">
                  <th mat-header-cell *matHeaderCellDef>Pass Rate</th>
                  <td mat-cell *matCellDef="let course">
                    {{ course.pass_rate > -1 ? course.pass_rate : 'NA' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="grade_awarded">
                  <th mat-header-cell *matHeaderCellDef>Grade Awarded</th>
                  <td mat-cell *matCellDef="let course">
                    {{ course.grade_awarded || 'NA' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="grade_prediction">
                  <th mat-header-cell *matHeaderCellDef>Grade Prediction</th>
                  <td mat-cell *matCellDef="let course">
                    {{ course.grade_prediction || 'NA' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="rank">
                  <th mat-header-cell *matHeaderCellDef>
                    Personalized Difficulty Rank <br />
                    (1 = Easy)
                  </th>
                  <td mat-cell *matCellDef="let course">
                    {{ course.rank || 'NA' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="delivery_method">
                  <th mat-header-cell *matHeaderCellDef>Delivery Method</th>
                  <td mat-cell *matCellDef="let course">
                    {{ course.delivery_method || 'NA' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element">
                    <button
                      class="expand-btn"
                      (click)="
                        expandedElement =
                          expandedElement === element ? null : element;
                        setInnerTableDataSource(+item.key)
                      "
                      mat-icon-button
                      aria-label="expand comment table"
                    >
                      <mat-icon>{{
                        expandedElement === element
                          ? 'expand_less'
                          : 'expand_more'
                      }}</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <ng-container matColumnDef="expandedDetail">
                  <td
                    mat-cell
                    *matCellDef="let element"
                    [attr.colspan]="displayedColumnsRegistered.length"
                  >
                    <div
                      class="example-element-detail"
                      [@detailExpand]="
                        element == expandedElement ? 'expanded' : 'collapsed'
                      "
                    >
                      <table
                        mat-table
                        [dataSource]="getInnerTableDataSource(+item.key)"
                        class="mat-elevation-z8 inner-table"
                      >
                        <!-- Course Section -->
                        <ng-container matColumnDef="course_section">
                          <th mat-header-cell *matHeaderCellDef>
                            Course Section
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.course_section || 'NA' }}
                          </td>
                        </ng-container>

                        <!-- Demo Time Frame -->
                        <ng-container matColumnDef="demo_time_frame">
                          <th mat-header-cell *matHeaderCellDef>
                            Demo Time Frame
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.demo_time_frame || 'NA' }}
                          </td>
                        </ng-container>

                        <!-- Enrollment State -->
                        <ng-container matColumnDef="enrollment_state">
                          <th mat-header-cell *matHeaderCellDef>
                            Enrollment State
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.enrollment_state || 'NA' }}
                          </td>
                        </ng-container>

                        <!-- Grade Score -->
                        <ng-container matColumnDef="grade_score">
                          <th mat-header-cell *matHeaderCellDef>Grade Score</th>
                          <td mat-cell *matCellDef="let element">
                            {{
                              element.grade_score === null
                                ? 'NA'
                                : element.grade_score
                            }}
                          </td>
                        </ng-container>

                        <!-- Grade Status -->
                        <ng-container matColumnDef="grade_status">
                          <th mat-header-cell *matHeaderCellDef>
                            Grade Status
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.grade_status || 'NA' }}
                          </td>
                        </ng-container>

                        <!-- Last Interaction Time -->
                        <ng-container matColumnDef="last_interaction_time">
                          <th mat-header-cell *matHeaderCellDef>
                            Last Interaction Time
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.last_interaction_time }}
                          </td>
                        </ng-container>

                        <!-- No Interactions -->
                        <ng-container matColumnDef="interacted_with_course">
                          <th mat-header-cell *matHeaderCellDef>
                            Interacted with Course
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.interacted_with_course || 'NA' }}
                          </td>
                        </ng-container>

                        <!-- Week -->
                        <ng-container matColumnDef="week">
                          <th mat-header-cell *matHeaderCellDef>Week</th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.week || 'NA' }}
                          </td>
                        </ng-container>

                        <tr
                          mat-header-row
                          *matHeaderRowDef="innerDisplayedColumns"
                        ></tr>
                        <tr
                          mat-row
                          *matRowDef="let row; columns: innerDisplayedColumns"
                        ></tr>
                      </table>
                    </div>
                  </td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsRegistered"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let element; columns: displayedColumnsRegistered"
                  class="example-element-row"
                  [class.example-expanded-row]="expandedElement === element"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: ['expandedDetail']"
                  class="example-detail-row"
                ></tr>
              </table>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>

  <!---------------------------- Student Graphs ---------------------------->
  <div *ngIf="studentData" class="charts-container">
    <div [class.mat-elevation-z8]="true" class="program-student-chart">
      <div class="chart-title-with-btn-icon">
        <p>Cumulative Student GPA with Program Change</p>
        <button
          matTooltip="Save chart as image"
          mat-icon-button
          aria-label="Chart snap icon"
          (click)="programStudentChart.exportChart()"
        >
          <mat-icon>photo_camera</mat-icon>
        </button>
      </div>
      <program-student-chart
        [studentTermPrograms]="studentTermPrograms"
        [studentTermGPAs]="studentsTermGPAs"
      >
      </program-student-chart>
    </div>

    <div
      class="chartjs-container"
      [class.mat-elevation-z8]="true"
      *ngIf="
        studentData.admit_type === 'FTIC' || studentData.admit_type === 'FCSAA'
      "
    >
      <div class="chart-title-with-btn-icon">
        <p>Program Hours Trend</p>
        <button
          matTooltip="Save chart as image"
          mat-icon-button
          aria-label="Chart snap icon"
          (click)="
            dataService.exportChartJsAsPNG(
              'hours-chart',
              'program-hours-trends'
            )
          "
        >
          <mat-icon>photo_camera</mat-icon>
        </button>
      </div>
      <canvas id="hours-chart">{{ hoursChart }}</canvas>
    </div>

    <div
      class="chartjs-container"
      [class.mat-elevation-z8]="true"
      *ngIf="
        studentData.admit_type === 'FTIC' || studentData.admit_type === 'FCSAA'
      "
    >
      <div class="chart-title-with-btn-icon">
        <p>Financial Aid Amount</p>
        <button
          matTooltip="Save chart as image"
          mat-icon-button
          aria-label="Chart snap icon"
          (click)="
            dataService.exportChartJsAsPNG(
              'financial-aid-chart',
              'financial-aid-amount-chart'
            )
          "
        >
          <mat-icon>photo_camera</mat-icon>
        </button>
      </div>
      <canvas id="financial-aid-chart">{{ financialAidChart }}</canvas>
    </div>

    <div
      class="chartjs-container"
      [class.mat-elevation-z8]="true"
      *ngIf="
        studentData.admit_type === 'FTIC' || studentData.admit_type === 'FCSAA'
      "
    >
      <div class="chart-title-with-btn-icon">
        <p>Average GPA Comparison</p>
        <button
          matTooltip="Save chart as image"
          mat-icon-button
          aria-label="Chart snap icon"
          (click)="
            dataService.exportChartJsAsPNG(
              'gpa-chart',
              'avg-gpa-comparison-chart'
            )
          "
        >
          <mat-icon>photo_camera</mat-icon>
        </button>
      </div>
      <canvas id="gpa-chart">{{ gpaComparisonChart }}</canvas>
    </div>
  </div>

  <back-button></back-button>
</div>
